module.exports = __webpack_public_path__ + "img/vuesax-linear-box-add.ddf558e5.svg";